<canvas #canvas [ngClass]="{ 'canvas': getUrl(), 'canvas-servicios': !getUrl()}"
  (mouseup)="verificarFirma()"
  (touchend)="verificarFirma()"></canvas>
<br>
<button class="btn btn-secondary w-100" (click)="clear()">Limpiar</button>
<!-- <button class="btn btn-primary ms-2" (click)="save()">Guardar</button> -->
